<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "command-center"
    }
</script>

<style scoped>
</style>
